import React, { useEffect, useState } from 'react';
import AppService from 'Services/AppService';
// import { asset } from 'Utils/envLoader';
import Navigator from 'Components/Shared/Navigator';

import { Link } from 'react-router-dom';
import { Table, Button } from 'react-bootstrap';
import { AiOutlinePlusCircle, AiOutlineDesktop } from 'react-icons/ai';
import { VscGlobe } from 'react-icons/vsc';

import IconTrueOrFalse from 'Components/Shared/IconTrueOrFalse';

import { BsLock, BsUnlock } from 'react-icons/bs';

const Apps = () => {
    const [apps, setApps] = useState([]);

    useEffect(() => {
        AppService.getApps()
            .then((result) => {
                if (result.status === 200) {
                    setApps(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    const disable = (appId) => {
        AppService.toggleDisableApp(appId)
            .then((response) => {
                const appInfo = response.data;
                const appsList = [...apps];
                const index = appsList.findIndex((d) => d.appId == appInfo.appId);
                appsList[index] = appInfo;
                setApps(appsList);
            })
            .catch((ex) => {
                console.log(ex);
            });
    };

    return (
        <>
            <Navigator section="Apps"></Navigator>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>apps</h2>
                <Link to="/admin/app/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Logo</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th className="text-center">Listed</th>
                        <th className="text-center">NoAuth</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Edit</th>
                        <th className="text-center">Delete</th>
                        <th className="text-center">Disable</th>
                    </tr>
                </thead>
                <tbody>
                    {apps.length ? (
                        apps.map((app, key) => {
                            return (
                                <tr key={key}>
                                    <td className="text-center">
                                        {app.appType === 1 && (
                                            <AiOutlineDesktop
                                                style={{
                                                    fontSize: '16pt',
                                                    color: 'black',
                                                }}
                                            />
                                        )}
                                        {app.appType === 0 && (
                                            <VscGlobe
                                                style={{
                                                    fontSize: '16pt',
                                                    color: 'black',
                                                }}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {app.logo && (
                                            <img
                                                src={app.logo}
                                                // src={asset + app.logo}
                                                alt=""
                                                style={{
                                                    height: '27pt',
                                                }}
                                            />
                                        )}
                                        {!app.logo && (
                                            <img
                                                src="/images/placeholder.png"
                                                alt=""
                                                style={{
                                                    height: '27pt',
                                                }}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {app.name}
                                        <i
                                            style={{
                                                fontSize: '7pt',
                                                display: 'block',
                                                fontStyle: 'normal',
                                            }}
                                        >
                                            {app.appId}
                                        </i>
                                    </td>
                                    <td>{app.description}</td>
                                    <td className="text-center">
                                        <IconTrueOrFalse value={app.listed} />
                                    </td>
                                    <td className="text-center">
                                        <IconTrueOrFalse value={app.noAuth} />
                                    </td>
                                    <td className="text-center">
                                        <IconTrueOrFalse value={app.disabled} />
                                    </td>
                                    <td className="text-center">
                                        <Link to={`/admin/app/edit/${app.appId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td className="text-center">
                                        <Link to={`/admin/app/delete/${app.appId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td className="text-center">
                                        <Link to="#" as={Button} onClick={() => disable(app.appId)}>
                                            {app.disabled === true ? (
                                                <BsUnlock
                                                    style={{
                                                        fontSize: '16pt',
                                                        color: 'blue',
                                                    }}
                                                />
                                            ) : (
                                                <BsLock
                                                    style={{
                                                        fontSize: '16pt',
                                                        color: 'red',
                                                    }}
                                                />
                                            )}
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="7">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default Apps;
